// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-menu-modal{top:0!important}.mobile-menu-modal .header-menu__container{display:grid;grid-auto-rows:min-content auto;min-height:var(--app-height-min);max-height:var(--app-height-min);height:var(--app-height-min)}.mobile-menu-modal .header-menu__body{overflow:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
